<div class="flex flex-col gap-1">
    <sms-label [required]="isRequired">{{ label }}</sms-label>
    <div class="flex justify-end gap-2 my-2 pl-2">
        <p-slider class="w-full" [min]="5" [formControl]="control" [step]="5"></p-slider>
        <div class="w-10 -mt-2">
            {{ control.getRawValue() }}
        </div>
    </div>
</div>
